

export const PublicInterceptorPR = async(URL, method, body = undefined, token = undefined) => {
    let respuesta = null;
    const promesa = await fetch(`${process.env.REACT_APP_API_URLPR}/${URL}?${Date.now()}`, { 
        method: method,
        headers: {
            "Content-Type": "application/json",
            'x-access-token': token
        },
        body: body && method !== 'GET' ? JSON.stringify(body) : undefined
    })

    await promesa.json()
    .then(function (res) {
        // console.log(res.data)
            respuesta =  res.data;
        })
        .catch((error) => {
            respuesta =  {error: error};
            console.error(respuesta);
        })
        return respuesta;
}